import React from 'react'
import ToolbarMail from '../../Includes/Toolbar/ToolbarMail'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  SET_MAIL,
  SEND_MAIL_ADMIN
} from '../../../Redux/Actions/Mail'
import {
  variables
} from '../../../Variables/Variables'

const MailToolbar = () => {
  const dispatch = useDispatch()
  const error = useSelector(state => state.mail.error)
  const mails = useSelector(state => state.mail.mails)
  const sujet = useSelector(state => state.mail.sujet)
  const texte = useSelector(state => state.mail.texte)
  const pending = useSelector(state => state.mail.pending)
  const Commit = () => {
    dispatch(SET_MAIL('pending', true))
    dispatch(SEND_MAIL_ADMIN(
      mails,
      sujet,
      texte,
      () => {
        dispatch(SET_MAIL('mail', ''))
        dispatch(SET_MAIL('mails', []))
        dispatch(SET_MAIL('users', []))
        dispatch(SET_MAIL('sujet', ''))
        dispatch(SET_MAIL('select', ''))
        dispatch(SET_MAIL('companie', ''))
        dispatch(SET_MAIL('pending', false))
        dispatch(SET_MAIL('texte', variables.mail.texte))
      }
    ))
  }
  return (
    <ToolbarMail
      data-testid="mail-envoyer"
      mails={mails}
      titre="Envoyer un mail"
      onClick={() => Commit()}
      disabled={(
        (mails.length > variables.mail.maximum) ||
        (mails.length === 0) ||
        (sujet === '') ||
        (texte === '') ||
        (error.sujet) ||
        (error.texte) ||
        (pending)
      )}
    />
  )
}

export default MailToolbar
